import { SorterResult } from 'antd/lib/table/interface';
import _ from 'lodash';
import { InboxSortMapper } from '@tools/ui/consts';
import { InboxTab, TableName } from '@tools/ui/enums';
import { SortFindManyTaskInput, Task } from '@tools/ui/types/generated/graphql';
import { DESCENDING_SORT_PREFIX } from './consts';

export const taskQuerySortBuilder = (
  accumulator: SortFindManyTaskInput[],
  current: SorterResult<Task>
): SortFindManyTaskInput[] => {
  if (current?.columnKey && current?.order) {
    accumulator.push(InboxSortMapper[current.columnKey][current.order]);
  }

  return accumulator;
};

export const getDefaultSortByInbox = (
  inbox: InboxTab
): SortFindManyTaskInput[] => {
  switch (inbox) {
    case InboxTab.live:
    case InboxTab.pending:
    case InboxTab.escalated:
      return [SortFindManyTaskInput.PRIORITIZATION_DESC];
    case InboxTab.archive:
      return [SortFindManyTaskInput.LASTDECISIONDETAILS__LASTDECISIONDATE_DESC];
    default:
      return [SortFindManyTaskInput.ENTITYCACHEDDATA__PAYMENT__ID_DESC];
  }
};

export const getDefaultSortByTable = (table: TableName): string => {
  switch (table) {
    case TableName.OdeHistory:
      return `${DESCENDING_SORT_PREFIX}id`;
    case TableName.PaymentsTab:
      return `${DESCENDING_SORT_PREFIX}id`;
    default:
      return `${DESCENDING_SORT_PREFIX}id`;
  }
};

export const compare = (
  value1?: string | number | null,
  value2?: string | number | null
): number => {
  if (value1 && value2) {
    const value1AsString = _.isNumber(value1) ? String(value1) : value1;
    const value2AsString = _.isNumber(value2) ? String(value2) : value2;
    return value1AsString.localeCompare(value2AsString, undefined, {
      numeric: true
    });
  }
  if (value1) {
    return 1;
  }
  if (value2) {
    return -1;
  }
  return 0;
};
